// import { Outlet } from "react-router-dom";
// import Header from "./header";
import HomePage from "./post"

export default function Layout() {
    return(
        <main>
            {/* <Header /> */}
            <HomePage/>
            {/* <Outlet /> */}
        </main>
    )
}